import { render, staticRenderFns } from "./NewFormatEditView.vue?vue&type=template&id=2e12cba6&scoped=true&"
import script from "./NewFormatEditView.vue?vue&type=script&lang=ts&"
export * from "./NewFormatEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12cba6",
  null
  
)

export default component.exports